<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <!-- <app-pagetitle [title]="'Displaying Vehicles of '+customerName" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table
              class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%"
            >
              <thead class="thead-light">
                <tr>
                  <th>S.No.</th>
                  <th>Registration - VIN Number</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Class</th>
                  <th>Fuel</th>
                  <th>Mileage</th>
                  <!-- <th>Action</th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of vehicles; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.regNumber }} - {{item.vin}}</td>
                  <td>{{ item.vehicleBrand }}</td>
                  <td>{{ item.vehicleModel }}</td>
                  <td>{{ item.vehicleClass }}</td>
                  <td>{{ item.fuelType }}</td>
                  <td>{{ item.epaArAiMileage }}</td>

                  <!-- <td>
                    <button
                      mat-button
                      class="btn btn-primary"
                      [matMenuTriggerFor]="menu"
                    >
                      Menu
                    </button>
                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        [routerLink]="[item.userVehicleId, 'trouble-codes']"
                        [queryParams]="{
                          name:
                            item.vehicleBrand +
                            '-' +
                            item.vehicleModel +
                            '-' +
                            item.regNumber
                        }"
                      >
                        Trouble Codes
                      </button>
                      <button
                        mat-menu-item
                        [routerLink]="['../../', 'driving-alerts']"
                        [queryParams]="{
                          name:
                            item.vehicleBrand +
                            '-' +
                            item.vehicleModel +
                            '-' +
                            item.regNumber,
                          vehicleId: item.userVehicleId
                        }"
                      >
                        Driving Alerts
                      </button>
                    </mat-menu>

                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
